/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./pinnedRecord.defs.js";
export { main as default } from "./pinnedRecord.defs.js";
